const enumBdwFhStatut = {
  "-1": "Non concerné",
  "0": "Concerné",
  "1": "En cours",
  "2": "Finalisé"
}

export { enumBdwFhStatut }



// WEBPACK FOOTER //
// ./src/enums/bdw/fhStatut.js